import { render, staticRenderFns } from "./CustomLogo.vue?vue&type=template&id=dfcb3c38&"
import script from "./CustomLogo.vue?vue&type=script&lang=js&"
export * from "./CustomLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports